<template>
  <div>
    <h1>Changelog</h1>

    <div class="flexRow changelog" v-for="(changes, key) in changelog">
      <div class="label">
        {{ key }}
      </div>
      <ul>
        <li v-for="change in changes">
          {{ change }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// FIXME - This is inefficient; not all clients will look at/need this
import changelog from "../changelog.js";

export default {
  name: "changelog-view",
  computed: {
    changelog() {
      return changelog;
    },
  },
};
</script>

<style scoped>
.flexRow {
  align-items: baseline;
}

.changelog {
  max-width: 800px;
  margin: auto;
}

/* FIXME - Do something more elegant here, please! Eventually represent progress with blocks? */
.changelog:nth-of-type(2) {
  border-bottom: 1px solid #ddd;
  padding-bottom: 2rem;
  margin-bottom: 2rem;
}

.label {
  width: 100px;
}

ul {
  display: inline-block;
  margin-left: 2rem;
  text-align: left;
  list-style-type: square;
  max-width: 650px;
}
</style>



// WEBPACK FOOTER //
// ChangelogView.vue?0db42989